import { makeStyles, createStyles } from '@material-ui/core/styles';

const pxToRem = (px, oneRemPx = 17) => `${px / oneRemPx}rem`;
const borderWidth = 2;
const width = pxToRem(44);
const height = pxToRem(26);
const size = pxToRem(20);
const gap = (40 - 32) / 2;
const primaryColor = '#9C27B0';

export const useSwitchStyles = makeStyles(() =>
  createStyles({
    root: {
      width,
      height,
      padding: 0,
      overflow: 'unset',
    },
    switchBase: {
      padding: pxToRem(gap),
      '&$checked': {
        color: '#fff',
        transform: `translateX(calc(${width} - ${size} - ${pxToRem(2 * gap)}))`,
        '& + $track': {
          opacity: 1,
          backgroundColor: primaryColor,
        },
        '& $thumb': {
          backgroundColor: '#fff',
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="14"><path d="M0 0h24v24H0z" fill="none"/><path fill="${encodeURIComponent(
            primaryColor
          )}" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>')`,
        },
      },
    },
    track: {
      borderRadius: 40,
      backgroundColor: '#E4E6EA',
      border: 'none',
      opacity: 1,
      borderWidth,
    },
    thumb: {
      width: size,
      height: size,
      boxShadow: 'none',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 24 24" width="12"><path fill="${encodeURIComponent(
        '#9CA3AF'
      )}" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    checked: {},
  })
);
